import { render, staticRenderFns } from "./switchLedTwoDialog.vue?vue&type=template&id=05a0f0ca&"
import script from "./switchLedTwoDialog.vue?vue&type=script&lang=js&"
export * from "./switchLedTwoDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchLedTwoDialog.vue?vue&type=style&index=0&id=05a0f0ca&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports